import {Disposable, Environment, commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {StartFlyPreviewInput, StartFlyPreviewMutation} from './__generated__/StartFlyPreviewMutation.graphql';
import RelayEnvironment from '../../RelayEnvironment';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

// Selects every field the fly previews page shows, so the returned record updates its row in the
// Mission Control store by id.
const mutation = graphql`
	mutation StartFlyPreviewMutation($input: StartFlyPreviewInput!) {
		startFlyPreview(input: $input) {
			flyPreview {
				id
				slug
				branchName
				webUrl
				status
				machinesTotal
				machinesRunning
				lastUsedAt
				lastUsedKnown
				createdAt
				deployedAt
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<StartFlyPreviewInput>,
	onSuccess: RelayOnCompleted<StartFlyPreviewMutation>,
	onError: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation(RelayEnvironment.getInstanceMC(), {
		mutation,
		variables,
		configs: [],
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
